<template>
  <div class="">
    <search-group title="" @search="findData" @clear="clearValue">
      <Row :gutter="16">
        <Col span="5">
          <Select placeholder="项目名称" v-model="searchData.projectFid" @on-change="changeProject">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <Select v-model="searchData.houseTypeFid" placeholder="房型名称">
            <Option value="">请选择</Option>
            <Option v-for="item in houseTypeList" :value="item.value" :key="item.value">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <Input class="block" v-model="searchData.houseNumber" placeholder="房间号" @keyup.enter.native="findData" />
        </Col>
        <Col span="5">
          <Input class="block" v-model="searchData.createBy" placeholder="修改人ID" @keyup.enter.native="findData" />
        </Col>
        <Col span="6">
          <DatePicker class="block" type="daterange" :editable=false split-panels placeholder="创建日期范围" v-model="createDate" @on-change="getCreateDate"></DatePicker>
        </Col>
        <Col span="5">
          <Select placeholder="修改价格类型" v-model="searchData.modifyType">
            <Option value="">请选择</Option>
            <Option v-for="(item,index) in modifyTypeList" :value="item.value" :key="'keyAA'+index">{{item.text}}</Option>
          </Select>
        </Col>
      </Row>
    </search-group>
  </div>
</template>

<script>
// import SearchGroup from "components/SearchGroup/index";
import { getProjects } from 'api/common'
import {getHouseType} from "api/house";

export default {
  // name: "SearchList",
  components: {
     // SearchGroup
  },
  data() {
    return {
      createDate: [],
      projectList:[],
      houseTypeList: [],
      modifyTypeList:[{text:'售价',value:1},{text:'优惠价',value:2}],
      searchData: {
        userInfo:'' ,
        operation: '',
        createTimeFrom: '',
        createTimeTo: '',
        modifyType:'',
      }
    };
  },
  methods: {
    findData() {
      this.$emit("findData", this.searchData);
    },
    clearValue() {
      this.createDate= []
      this.searchData= {
        userInfo:'' ,
        operation: '',
        createTimeFrom: '',
        createTimeTo: '',
        modifyType:'',
      }
    },
    getCreateDate(val){
      this.searchData.createTimeFrom = val[0]
      this.searchData.createTimeTo = val[1]
    },
    changeProject(value) {
      if (value !== '') {
        this.getHouseTypeListByProFid(value)
      } else {
        this.houseTypeList = []
      }
    },
    getHouseTypeListByProFid(projectFid) {

      getHouseType(projectFid).then(res => {
        this.houseTypeList = res.data.houseTypeList
      })
    },
  },
  created() {
    getProjects().then( res => {
      this.projectList = res.data
    })
    this.$emit('findData',this.searchData)
  }
};
</script>
<style scoped>
  .flex {
    display: block;
  }
  .search-wrapper {
    padding: 24px 0 !important;
  }

  .shortcut a {
    display: inline-block;
    padding: 10px 20px;
    font-weight: bold;
    color: #444444;
  }

  .width200 {
    width: 200px;
  }

  .width300 {
    width: 300px;
  }

  .block {
    display: block;
  }
</style>
